import { render, staticRenderFns } from "./negotiate.vue?vue&type=template&id=fbe896b8"
import script from "./negotiate.vue?vue&type=script&lang=js"
export * from "./negotiate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports